if (!customElements.get('edifier-bby-locator')) {
customElements.define('edifier-bby-locator', class extends HTMLElement {
connectedCallback() {
  const root = this;
  if (!root || root.dataset.initialized === 'true') return;
  root.dataset.initialized = 'true';
  const input = root.querySelector('input'), form = root.querySelector('form'), summary = root.querySelector('.edf-bby-locator__summary');
  const results = root.querySelector('.edf-bby-locator__results'), more = root.querySelector('.edf-bby-locator__more');
  const limit = Math.max(1, Number(root.dataset.pageSize) || 12);
  const stateNames = {AL:'Alabama',AK:'Alaska',AZ:'Arizona',AR:'Arkansas',CA:'California',CO:'Colorado',CT:'Connecticut',DE:'Delaware',FL:'Florida',GA:'Georgia',HI:'Hawaii',ID:'Idaho',IL:'Illinois',IN:'Indiana',IA:'Iowa',KS:'Kansas',KY:'Kentucky',LA:'Louisiana',ME:'Maine',MD:'Maryland',MA:'Massachusetts',MI:'Michigan',MN:'Minnesota',MS:'Mississippi',MO:'Missouri',MT:'Montana',NE:'Nebraska',NV:'Nevada',NH:'New Hampshire',NJ:'New Jersey',NM:'New Mexico',NY:'New York',NC:'North Carolina',ND:'North Dakota',OH:'Ohio',OK:'Oklahoma',OR:'Oregon',PA:'Pennsylvania',RI:'Rhode Island',SC:'South Carolina',SD:'South Dakota',TN:'Tennessee',TX:'Texas',UT:'Utah',VT:'Vermont',VA:'Virginia',WA:'Washington',WV:'West Virginia',WI:'Wisconsin',WY:'Wyoming',DC:'District of Columbia',PR:'Puerto Rico',VI:'Virgin Islands',GU:'Guam'};
  let stores = [], matched = [], shown = 0;
  function normalize(value) { return String(value || '').toLowerCase().trim().replace(/[^a-z0-9]+/g, ' ').trim(); }
  function matches(store, query) {
    if (!query) return true;
    const fields = [store.city, store.state, stateNames[store.state] || '', store.zip];
    return fields.some(field => normalize(field).includes(query)) || normalize(store.city + ' ' + store.state).includes(query) || normalize(store.city + ' ' + (stateNames[store.state] || '')).includes(query);
  }
  function node(tag, cls, value) { const el = document.createElement(tag); if (cls) el.className = cls; if (value != null) el.textContent = value; return el; }
  function locationIcon() {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('class', 'edf-bby-locator__location-icon');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('aria-hidden', 'true');
    const pin = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    pin.setAttribute('d', 'M20 10c0 5-8 11-8 11S4 15 4 10a8 8 0 1 1 16 0Z');
    const dot = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    dot.setAttribute('cx', '12'); dot.setAttribute('cy', '10'); dot.setAttribute('r', '2.5');
    svg.append(pin, dot); return svg;
  }
  function card(store) {
    const article = node('article', 'edf-bby-locator__card');
    const body = node('div', 'edf-bby-locator__card-body');
    const address = node('p', 'edf-bby-locator__address');
    address.append(node('span', 'edf-bby-locator__address-line', store.address));
    address.append(node('span', 'edf-bby-locator__address-line', store.city + ', ' + store.state + ' ' + store.zip));
    body.append(node('h3', '', 'Best Buy – ' + store.name), address);
    article.append(locationIcon(), body);
    const links = node('div', 'edf-bby-locator__links');
    if (store.phone) { const phone = node('a', '', 'Tel:' + store.phone); phone.href = 'tel:' + store.phone.replace(/[^\d+]/g, ''); links.append(phone); }
    const directions = node('a', '', 'Get directions ↗');
    directions.href = 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent([store.address, store.city, store.state, store.zip].join(', '));
    directions.target = '_blank'; directions.rel = 'noopener noreferrer';
    links.append(directions); article.append(links); return article;
  }
  function appendPage() {
    const next = matched.slice(shown, shown + limit);
    const fragment = document.createDocumentFragment(); next.forEach(s => fragment.append(card(s)));
    results.append(fragment); shown += next.length; more.hidden = shown >= matched.length;
  }
  function search() {
    const q = normalize(input.value);
    matched = stores.filter(s => matches(s, q)).sort((a,b) => a.state.localeCompare(b.state) || a.city.localeCompare(b.city) || a.name.localeCompare(b.name));
    shown = 0; results.replaceChildren();
    summary.textContent = matched.length ? matched.length + ' participating ' + (matched.length === 1 ? 'store' : 'stores') + ' found' : 'No matching stores found. Try another city, state or ZIP code.';
    appendPage();
  }
  form.addEventListener('submit', e => {e.preventDefault(); search();});
  input.addEventListener('input', search);
  more.addEventListener('click', appendPage);
  function loadStores() {
    if (Array.isArray(window.EDIFIER_BBY_STORE_LOCATIONS)) return Promise.resolve(window.EDIFIER_BBY_STORE_LOCATIONS);
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = root.dataset.url;
      script.async = true;
      script.onload = () => {
        if (Array.isArray(window.EDIFIER_BBY_STORE_LOCATIONS)) resolve(window.EDIFIER_BBY_STORE_LOCATIONS);
        else reject(new Error('Invalid store data'));
      };
      script.onerror = () => reject(new Error('Store data unavailable'));
      document.head.append(script);
    });
  }
  loadStores().then(data => {stores = data; search();}).catch(error => {
    console.error('Edifier Best Buy locator:', error);
    summary.textContent = 'Store locations are temporarily unavailable. Please try again later.';
    more.hidden = true;
  });
}
});
}